<template>
	<div class="processedDetail">
		<div style="font-size: 18px;margin-bottom: 20px;" @click="hfkf">{{$t('processed.RecordDetails')}}</div>

		<el-dialog :title="textDesc" :visible.sync="dialogVisible" width="50%" >
		<el-table
		:data="tableData"
		border
		style="width: 100%">
		<el-table-column prop="logisticsRule.logisticsName" :label="$t('processed.Couriername')" ></el-table-column>
		<el-table-column prop="logisticsRule.firstWeight" :label="$t('processed.firstheavy')" ></el-table-column>
		<el-table-column prop="logisticsRule.firstFee" :label="$t('processed.heavycost')" ></el-table-column>
		<el-table-column prop="logisticsRule.weightFee" :label="$t('processed.Continuedheavy')" ></el-table-column>
		<el-table-column  :label="$t('processed.chargemode')" >
			<template slot-scope="scope">
				<span>{{scope.row.type == 0 ? volumeweight : scope.row.type == 1 ? weight : Takeofboth }}</span>
			</template>
		</el-table-column>
		</el-table>
		<div v-if="tableData.length > 0" style="margin-top:20px;font-size:18px;font-weight:500">
			<span style="margin-right:20px">{{$t('processed.actualweight')}}:{{tableData[0].weight}}kg</span>
			<span style="margin-right:20px">{{$t('processed.actualvolume')}}:{{tableData[0].length}} X {{tableData[0].width}} X {{tableData[0].height}} cm</span>
			<span style="margin-right:20px;color:red">{{$t('processed.actualcharges')}}:{{tableData[0].paidIntegral}} {{$t('processed.integral')}}</span>
		</div>

		<div v-if="tableData.length > 0 && userPos == 'STORE'" style="margin-top:20px;font-size:18px;font-weight:500">
			<span style="margin-right:20px">{{$t('processed.Actualexpressfee')}}:{{tableData[0].actualCost}}</span>
			<span style="margin-right:20px">{{$t('processed.currency')}}:{{tableData[0].currency}}</span>
		</div>

		<div v-if="tableData.length > 0" style="margin-top:20px;font-size:18px;font-weight:500">
			<span style="margin-right:20px">{{$t('processed.Actualexpressfee')}}:{{tableData[0].actualCost}}</span>
			<span style="margin-right:20px">{{$t('processed.currency')}}:{{tableData[0].currency}}</span>
			
			
		</div> 
		<span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible = false">{{$t('processed.cancel')}}</el-button>
			<el-button type="primary" @click="dialogVisible = false">{{$t('processed.confirm')}}</el-button>
		</span>
		</el-dialog>
		<div class="ppo">
            <div class="ppo-item">{{$t("other.a861")}}：{{time}}</div>
			<div class="ppo-item">{{$t("other.a862")}}：{{totalIntetal}}</div>
            <div class="ppo-item">{{$t("other.a863")}}：{{feeCount}}</div>
			
			<div class="ppo-item" >
				<el-button size="medium" type="primary" @click="exportXml()">{{$t("other.a864")}}</el-button>
			</div>
		</div>
					  <el-table ref="multipleTable" :data="tableList"  tooltip-effect="dark" border style="width: 100%;margin-bottom: 50px;" select-all="checkedall"
					   @selection-change="handleSelectionChange">
					  	<el-table-column type="selection" width="59">
					  	</el-table-column>
					  	<el-table-column label="order ID">
					  		<template slot-scope="scope">
                                  <div>{{scope.row.payOrderId}}</div>
					  		</template>
					  	</el-table-column>
						<el-table-column label="order Time">
							<template slot-scope="scope">
								<div class="ordersn-box">{{$t('complaint.orderTime')}}：{{scope.row.createTime}}</div>
							</template>
						</el-table-column>
					  	<!-- <el-table-column label="Product(s)" width="250">
					  		<template slot-scope="scope">
                                  <div class="ordersn-box">{{$t('complaint.orderTime')}}：{{scope.row.createTime}}</div>
					  		</template>
					  	</el-table-column> -->
					  	<el-table-column prop="address" label="Integral" show-overflow-tooltip>
					  		<template slot-scope="scope">
					  			
					  			<div class="ordersn-box">{{$t("other.a863")}}：{{ scope.row.changeIntegral}}</div>
					  		</template>
					  	</el-table-column>
					  </el-table>
	</div>
</template>

<script>
		import {mapState, mapActions , mapMutations} from 'vuex'
		import utils from '../../../utils/utils.js'
		import newOrders from '../../../api/moudles/newOrders'
        import deductionApi from '../../../api/moudles/deduction'

	export default{
		data(){
			return {
				volumeweight:this.$t("processed.volumeweight"),
				weight:this.$t("userStoreItems.weight"),
				Takeofboth:this.$t("processed.Takeofboth"),
				description:this.$t("allorders.description"),
				itemnum:this.$t("allorders.item"),
				setmeal:this.$t("allorders.setmeal"),
				tableList:[],
				shopInfo:null,
				textarea:'',
				textDesc:'',
				dialogVisible:false,
				tableData:[],
                totalIntetal:0,
                time:null,
                feeCount:0
				
			}
		},
		computed:{
			...mapState({
				userId: state=>state.login.userInfo.userId || '',
				vipLevel:state=>state.login.userInfo.vipLevel || '',
				userPos: state=>state.login.userInfo.userPos,
			
				
			}),
			
		
		},
		watch:{
			
		},
        beforeDestroy(){
            localStorage.removeItem('distribution')
        },
		created(){
			this.hfkf()
		},
		methods:{

			reStart(item){
				console.log(item)
				newOrders
				.sartReadyOrders([{
					orderId:item.orderId,
					shopId:item.shopId,
					type:0,
					userId:this.userId
				}]).then(res => {
				if(res.code === 200 ){

				}else{
				this.$message.warning(res.msg)
				}
				})
			},

			exportXml(){
			   let list=JSON.parse(localStorage.getItem('distribution'))
				deductionApi
				.getIntegralLog(list)
				.then(res => {
					if(res.code === 200 ){
						let arr=[]
						res.data.logs.forEach(p => {
							arr.push({
								'订单号':p.payOrderId,
								'下单时间':p.createTime,
								'支付积分':p.changeIntegral,
							})
						})
						let list= ['订单号','下单时间','支付积分']
						let tip='DeductionPoints'
						utils.exPortEXml(arr,list,tip)
					}
				})
			},
			
			rePrinted(item){
				console.log(item)
				if(item.platform == 'LAZADA'){
					let Base64 = require('js-base64').Base64
					let file=item.orderPdf.html
					let newfile=Base64.decode(file)
					localStorage.removeItem('alipay')
					localStorage.setItem('html',newfile)
					let newUrl=location.host + '/sealpage'
					console.log(newUrl)
					window.open('https://' + newUrl)

				}else if(item.platform == 'SHOPEE'){

					
						window.open(item.orderPdf.pdf)
				

				}
			},


			kvjmfh(id){
				console.log(id)
				let ttp=null
				if(id && id.initType == 0){
					ttp = 'Drop off' 
				}else if(id && id.initType == 1){
					ttp = 'Pick up' 
				}
				return ttp
			}, 

			getFee(id){
				console.log(id)
				newOrders
				.queryLogisticsOrder({orderId:id})
				.then(res => {
				if(res.code === 200 ){
				console.log('desc',res.data)
				this.textDesc= this.$t("homeTwo.SubInspection") +id + this.$t("processed.Actualexpressfee")
				this.tableData=[res.data]
				this.dialogVisible=true
				}else{
				this.$message.warning(res.msg)
				}
				})
				
			},
			
			
			mergerPrintPicklist05(){
				utils.cleanStorageData()
				let list=[]
				console.log(this.multipleSelection)
				this.tableList.forEach(p => {
					list.push(p.orderId)
				})
				
				
				localStorage.setItem('picklistInfoCopy',JSON.stringify(list))
				const {href}=this.$router.resolve({
					name:'lazadaDefualtPicklist',
				
				}) 
				window.open(href)
			
			},
			showShopName(id){
				let ccp=null
				if(this.userPos === 'SELLER'){
					ccp=utils.showshopNameByshopId()
					
					return ccp[id]
				}else if(this.userPos === 'STORE'){
					 ccp=utils.showstoreNameBystoreId(id) 
					
					return ccp
				}
				
				
			},

			CopyText(id){
				console.log(id)
				let _input = document.createElement("input");   // 直接构建input
				　　_input.value = id;  // 设置内容
				　　document.body.appendChild(_input);    // 添加临时实例
				　　_input.select();   // 选择实例内容
				　　document.execCommand("Copy");   // 执行复制
				　　this.$message.success(this.$t("orderPrint.Copy"))
				　　document.body.removeChild(_input); // 删除临时实例
			},
			
			getTime(item) {
				if (!item) {
					return this.$t('shippedorder.pending_upgrade')
				} else {
					return utils.renderTime(item)
				}
			
			},
			hfkf(){

                let list=JSON.parse(localStorage.getItem('distribution'))
                this.time=list.start+ '/' +list.end
                console.log(list)
                this.getRecharge(list)

				// let ttp=JSON.parse(localStorage.getItem('tableList'))
				// ttp.list.forEach(p => {
				// 	let stores=JSON.parse(localStorage.getItem('userInfo')).stores
				// 	let obj=stores.find(item => item.storeId === p.storeId)
				// 	console.log(obj)
				// 	if(obj.storeAddress == 'CN' && obj.storeType == 1){
				// 		p.chinessOverSean=true
				// 	}else{
				// 		p.chinessOverSean=false
				// 	}
				// })


				// this.isShopee=ttp.list[0].platform
				// this.tableList=ttp.list
				// this.shopInfo=ttp.shopInfo
				// console.log(ttp)

                
				
			},

            //获取积分变化明细
			getRecharge(list){
				deductionApi
				.getIntegralLog(list)
				.then(res => {
					if(res.code === 200) {
						console.log('收入支出',res.data)
                        res.data.logs.forEach(p => {
                            p.createTime=utils.renderTime(p.createTime)
                        })

                        this.tableList=res.data.logs
                        this.totalIntetal=res.data.count
                        this.feeCount=res.data.feeCount


					}else{
						this.$message.warning(res.msg)
					}
				})
			},
			handleSizeChange(val) {
				this.offset=Number(`${val}`)
				console.log(this.offset);
			 },
			handleCurrentChange(val) {
				this.page=this.offset*(Number(`${val}`) -1)
				this.getOrdersn({
					offset:this.offset,
					page:this.page,
					shopIds:this.shopIdlist,
					storeIds:this.warehouse,
				})	
			},
			handleSelectionChange(val) {
				console.log(val)
				if(val.length === this.choseOrderList.length || val.length === this.orderList2.length){
					this.chooseAll=true
				}else{
					this.chooseAll=false
				}
				this.multipleSelection = val
				console.log(this.multipleSelection)
			
			},
		}
			
	}
</script>

<style>

	
	.processedDetail {
		/* flex: 1; */
		width: 100%;
		box-sizing: border-box;
		padding: 0 20px;
		/* margin: 60px 0 0 0px; */
		position: absolute;
	}
	
	.processedDetail .order-list-item {
		position: relative;
		padding-bottom: 10px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
	}
	
	.processedDetail .order-title {
	
		border-bottom: 1px #E0E0E0 solid;
	}
	
	.processedDetail .order-title-count {
		color: red;
		font-style: inherit;
		margin-left: 10px;
	}
	
	.processedDetail .order-query {
		display: flex;
		justify-content: start;
		align-items: center;
		padding: 10px;
		border-bottom: 1px #E0E0E0 solid;
	}
	
	.el-tooltip__popper.is-dark{
		background: #000000!important;
	}
	
	
	
	.processedDetail .order-query .query {
		position: relative;
		margin-right: 30px;
	}
	
	.processedDetail .list-btn {
		padding: 20px 15px;
	}
	
	.processedDetail .list-desc {
		margin-left: 15px;
		border-bottom: 1px #eee solid;
	}
	
	.processedDetail .list-desc-item {
		font-size: 14px;
	
		padding-right: 15px;
	}
	
	.icon-box {
	    width: 22px; height: 22px; cursor: pointer; display: inline-block;
	}
	 .icon-box.svg-box:hover {
	     color: tomato;
	 }
	
	.processedDetail .list-item-status {
		color: red;
	}
	
	.processedDetail .didan {
		font-size: 24px;
	}
	
	.processedDetail .list-content {
		display: flex;
		justify-content: space-around;
		/* margin: 20px;
	padding: 20px; */
		/* box-shadow: 0 2px 12px 0 rgba(0,0,0,.1); */
	}
	
	.processedDetail .order-pic {
		width: 80px;
		height: 80px;
	}
	
	img {
		width: 100%;
	}
	
	.processedDetail .list-content-left,
	.list-content-right {
		display: flex;
	
	}
	
	.processedDetail .list-item-wrapper {
		box-sizing: border-box;
		padding: 15px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
	}
	
	.processedDetail .order-selec {
		width: 150px;
		margin: 0 10px;
	}
	
	.processedDetail .block-ttp {
		width: 350px !important;
	}
	
	.processedDetail .order-desc {
		width: 30%;
	}
	
	.processedDetail .order-title-desc {
		margin-bottom: 15px;
	}
	
	.stroeVisble .el-input__inner{
		width: 99%;
		height: 130px;
		font-size: 30px
	}
	
	.processedDetail .list-price-item,
	.shoper-name {
		padding: 2px 0;
	}
	
	.processedDetail .list-number,
	.list-price {
		margin-left: 40px;
	}
	
	.list-price-btn {
		display: flex;
		flex-direction: column;
	}
	
	.list-price-btn-item {
		margin-top: 20px;
		margin-left: 0 !important;
		width: 120px;
	}
	
	.processedDetail .primary-btn {
		display: inline-block;
		margin: 0 30px;
	}
	
	.second-menu-wrapper {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	
	.asb {
		position: relative;
	}
	
	.dialog-wrapper {
		display: flex;
		flex-wrap: wrap;
		position: absolute;
		top: 50px;
		left: -600px;
		bottom: 0;
		right: 0;
		width: 600px;
		background-color: #fff;
		margin: 0 auto;
		z-index: 40;
		box-shadow: 0 0 25px #cac6c6;
	
	}
	
	.dialog-wrapper-item {
		display: inline-block;
		width: 100px;
		height: 100px;
		box-sizing: border-box;
		background-color: #fff;
		padding: 5px;
	}
	
	
	.processedDetail .second-menu {
		display: flex;
		justify-content: flex-start;
		position: relative;
	
	}
	
	.processedDetail .menu-right-btn {
		margin-right: 30px;
		color: #606266;
		;
	}
	
	
	.el-icon-loading:before {
	    content: "\E6CF";
	    font-size: 20px;
	}
	
	.notify-boxw{
		width: 330px;
		height: 80px;
		box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
		position: absolute;
		top: 150px;
		right: 30px;
		border-radius: 8px;
		box-sizing: border-box;
		padding: 10px;
		z-index: 999999;
	}
	
	.processedDetail .second-menu-left {
	
		display: flex;
		;
	
	}
	
	.processedDetail .search-box {
		/* 	width: 100px; */
		/* margin: 0 10px 0px 10px; */
	}
	
	
	.processedDetail .sousuo-box {
		width: 300px;
		margin-right: 20px;
	}
	
	.processedDetail .chekbox {
		width: 30px;
		height: 30px;
	}
	
	.processedDetail .Pager{
		position: fixed;
		bottom: 0;
		left: 235px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
		
		
	
		
	}
	
	.processedDetail .el-pagination {
		display: flex;
		justify-content: flex-end;
		margin: 0 10px 10px 0;
	}
	
	.processedDetail .nodata {
		margin-top: 100px;
		text-align: center;
		color: #000;
	}
	
	.processedDetail .checkallbox {
		margin: 7px;
		padding-left: 5px;
		color: #606266;
		font-size: 14px;
		cursor: pointer;
	
	}
	
	.processedDetail .checkallbox:hover {
		color: #409EFF;
	}
	
	.processedDetail .checkallbox-oop:hover {
		color: #409EFF;
	}
	
	.processedDetail .blank {
		color: #606266;
		text-decoration: none;
	}
	
	.processedDetail .createOrder {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		margin-top: 10px;
	}
	
	.processedDetail .createOrder-item {
		margin: 0 10px;
	}
	
	.processedDetail .el-dropdown-link {
		color: #606266 !important;
	}
	
	/* 	.loading-box{
		display: inline-block;
		height: 30px;
	} */
	
	.processedDetail .list-desc {
		display: flex;
		align-items: center;
		margin-left: 15px;
		border-bottom: 1px #eee solid;
	}
	
	.processedDetail .chekbox {
		width: 30px;
		height: 30px;
		line-height: 30px;
	}
	
	.processedDetail .pic-box {
		display: flex;
		margin: 2px;
		width: 80px;
		height: 80px;
	}
	
	.processedDetail .return-item {
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
		padding: 10px;
		font-size: 14px;
	}
	
	.processedDetail .return-item-list {
		display: flex;
		align-items: center;
	
	}
	
	.processedDetail .unfold:nth-of-type(n+4) {
		display: none;
	
	}
	
	.processedDetail .pic-box-desc {
		width: 250px;
		margin-left: 20px;
	}
	
	.processedDetail .retrun-reasonr {
		margin-left: 30px;
	}
	
	.processedDetail .retrun-reasonr-btn {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-right: 20px;
	}
	
	.processedDetail .seller {
		margin-right: 10px;
		font-size: 18px;
	}
	
	.processedDetail .return-reasonr-desc {
		box-sizing: border-box;
		padding: 3px 0;
	}
	
	.processedDetail .seller-item {
		margin-left: 15px;
		font-size: 14px;
	}
	
	.processedDetail .seller-ppc {
		color: red;
	}
	
	.ppo{
		    display: flex;
		    flex-wrap: wrap;
			height: 40px;
		    padding: 5px 10px;
		    margin: 0px -5px;
		    -webkit-box-align: center;
		    align-items: center;
		    background: rgb(61, 70, 77);
		    color: rgb(255, 255, 255);
		    border-top: 10px solid rgb(255, 255, 255);
		    border-bottom: 10px solid rgb(255, 255, 255);
		    border-radius: 2px;
			
	}
	
	.ppo-item{
		font-size: 18px;
		color: #fff;
		margin-right: 10px;
	}
	
	
	
	
	
	
	
	.ordersn-box {
		font-size: 12px;
	}
	
	.pic-wrapper {
		display: inline-block;
		width: 40px;
		height: 40px;
		margin-right: 5px;
		position: relative;
	}
	
	.pic-wrapper-quantity {
		position: absolute;
		top: 0;
		right: 0;
		display: inline-block;
		width: 15px;
		height: 15px;
		line-height: 15px;
		background-color: red;
		font-size: 8px;
		color: #fff;
		text-align: center;
	}
	
	.IdScaneArea .el-input__inner{
	width: 99%;
	height: 130px;
	font-size: 30px
	}
	
	.flagbox{
		display: inline-block;
		width: 56px;
		height: 30px;
	}
	
	.flagbox .el-radio{
		    display: flex;
		    align-items: center;
	}
	
	.flagbox .el-radio__label{
		padding-left:5px!important;
	}
	
</style>
